module.exports = __webpack_public_path__ + "img/sun_two_clouds.d23fdd14.png";